import brand from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import fonts from '@helpers/fonts';
import { baseGrid } from '@helpers/grid';
import { Device, from } from '@helpers/media';
import { h3, link, paragraphRegular, reverseLinkUnderline } from '@helpers/typography';
import ButtonStyles from '@stories/Components/Buttons/Button/Button.styles';
import FormStyles from '@stories/Components/Misc/Forms/Form.styles';
import SectionWrapper from '@stories/Components/Misc/SectionWrapper/SectionWrapper';
import SectionWrapperStyles from '@stories/Components/Misc/SectionWrapper/SectionWrapper.styles';
import { rgba } from 'polished';
import styled from 'styled-components';
const Container = styled(SectionWrapper) `
  --sectionBackground: ${rgba(brand.primary.blue.light, 0.2)};

  position: relative;

  @media print {
    display: none;
  }

  ${SectionWrapperStyles.Inner} {
    @media ${from(Device.TabletLarge)} {
      ${baseGrid};
    }
  }
`;
const Wrapper = styled.div `
  border-radius: ${fluid(10, 20)};
  overflow: hidden;

  @media ${from(Device.TabletLarge)} {
    grid-column: 3 / span 8;
    box-shadow: 0px 4px 12.1px 6px rgba(217, 217, 217, 0.2);
  }

  @media ${from(Device.Desktop)} {
    grid-column: 4 / span 6;
  }
`;
const Top = styled.div `
  background-color: ${brand.primary.purple.light};
  color: ${brand.global.white};
  padding: ${fluid(24, 59)} ${fluid(16, 145)} ${fluid(24, 56)};
  text-align: center;
`;
const Heading = styled.h3 `
  ${h3};
  margin-bottom: 9px;
`;
const Summary = styled.p `
  ${paragraphRegular};
  margin-bottom: 0;
  font-size: ${fluid(14, 18)};
`;
const FormContainer = styled.div `
  background-color: ${brand.global.white};
  padding: 40px 16px;

  @media ${from(Device.TabletLarge)} {
    padding: 36px ${fluid(16, 145)} 48px;
  }

  ${FormStyles.Form} {
    margin: 0 auto;
  }

  ${FormStyles.SubmitWrapper} {
    ${ButtonStyles.Container} {
      width: 100%;
      justify-content: center;
    }
  }
`;
const UnderForm = styled.div `
  text-align: center;
  margin-top: 8px;
`;
const Bottom = styled.div `
  margin-top: ${fluid(24, 40)};
  border-top: 1px solid ${brand.grey.light};
  padding-top: ${fluid(20, 20)};
  text-align: center;
`;
const BaseLink = styled.p `
  ${fonts.lato.regular};
  font-size: ${fluid(14, 16)};
  line-height: ${fluid(20, 24)};
`;
const Link = styled.a `
  ${link};
  ${reverseLinkUnderline};

  --textLinkColour: ${brand.primary.purple.dark};
`;
const LogInSignUpStyles = {
    BaseLink,
    Bottom,
    Container,
    FormContainer,
    Heading,
    Link,
    Summary,
    Top,
    UnderForm,
    Wrapper,
};
export default LogInSignUpStyles;
